var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 32",
    style: {
      enableBackground: "new 0 0 34 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.grouplistst0{fill:#595F64;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "grouplistst0",
    d: "M13.3,5.7h19.3c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4H13.3c-0.8,0-1.4,0.6-1.4,1.4 C11.9,5.1,12.5,5.7,13.3,5.7z M3.8,0.5C1.7,0.5,0,2.2,0,4.3c0,2.1,1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8C7.6,2.2,5.9,0.5,3.8,0.5z  M32.6,14.6H13.3c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4h19.3c0.8,0,1.4-0.6,1.4-1.4C34,15.2,33.4,14.6,32.6,14.6z  M3.8,12.2C1.7,12.2,0,13.9,0,16s1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8S5.9,12.2,3.8,12.2z M32.6,26.3H13.3c-0.8,0-1.4,0.6-1.4,1.4 c0,0.8,0.6,1.4,1.4,1.4h19.3c0.8,0,1.4-0.6,1.4-1.4C34,26.9,33.4,26.3,32.6,26.3z M3.8,23.9c-2.1,0-3.8,1.7-3.8,3.8 c0,2.1,1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8C7.6,25.6,5.9,23.9,3.8,23.9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupList);
export default __webpack_public_path__ + "static/media/groupList.3eb8b4c9.svg";
export { ForwardRef as ReactComponent };